import { render, staticRenderFns } from "./BaseNewsTileTriple.vue?vue&type=template&id=699607c6&"
import script from "./BaseNewsTileTriple.vue?vue&type=script&lang=js&"
export * from "./BaseNewsTileTriple.vue?vue&type=script&lang=js&"
import style0 from "./BaseNewsTileTriple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports